import React, { useEffect, useRef, useState } from 'react';
import { Button, CloudDownloadIcon, Dialog, EditIcon, PlusIcon, TrashIcon } from "evergreen-ui";
import { Card, message, Table, Tag, Tooltip } from "antd";
import { MDBBox, MDBCol, MDBRow } from "mdbreact";
import LangEditLayout from "../ModalActionLayout/LangEditLayout";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals, useObjectVal } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { getDownloadURL, getStorage, ref as storageRef } from "firebase/storage";
import TableActionMenu from "../../../Common/TableActionMenu";
import {
	describeImportSummary,
	exportTranslationSheet,
	getTranslationProgress,
	importTranslationFile,
} from "../../../utils/translationSheets";

var db = getDatabase(Firebase);
var storage = getStorage(Firebase);
const LanguageLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'Language',
			dataIndex: 'language',
			key: 'language',
			sorter: (a, b) => a.language && a.language.localeCompare(b.language),
		},
		{
			title: 'UI Translation',
			dataIndex: 'progress',
			key: 'progress',
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]

	const [languagesArray, setLanguagesArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/languages"));
	const [uiStrings] = useListVals(ref(db, "talmidsdb/uiStrings"));
	const [translations] = useObjectVal(ref(db, "talmidsdb/translations"));
	const importInput = useRef(null);
	const importTarget = useRef(null);
	const [showModal, setShowModal] = useState(false);
	const [layout, setLayout] = useState(null);


	const handleCallback = (data) => {
		if (data === "true") {
			setShowModal(false);
			//window.location = window.location;
		}
	}
	const downloadLanguageFile = (item) => {
		const paths = [
			item.translationFilePath,
			item.id ? `talmidsdb/languages/${item.id}.csv` : null,
			item.languageID ? `talmidsdb/Languages/${item.languageID}` : null,
			item.id ? `talmidsdb/Languages/${item.id}` : null,
		].filter(Boolean);

		const tryPath = (index = 0) => {
			if (index >= paths.length) {
				message.error("No file found for this language");
				return;
			}

			getDownloadURL(storageRef(storage, paths[index]))
				.then((url) => {
					const xhr = new XMLHttpRequest();
					xhr.responseType = 'blob';
					xhr.onload = () => {
						const blob = xhr.response;
						var link = document.createElement('a');
						link.download = item.languageName || item.language || "language";
						link.href = window.URL.createObjectURL(blob);
						link.click();
					};
					xhr.open('GET', url);
					xhr.send();
				}).catch(() => tryPath(index + 1));
		};

		tryPath();
	};
	const handleExport = (item, mode) => {
		const count = exportTranslationSheet({
			uiStrings,
			languageTranslations: translations?.[item.id],
			language: item,
			mode,
		});
		if (count === 0) {
			message.info("Nothing to translate: every UI string is already translated for this language.");
		}
	};

	const startImport = (item) => {
		importTarget.current = item;
		importInput.current?.click();
	};

	const handleImport = (e) => {
		const file = e.target.files?.[0];
		const item = importTarget.current;
		e.target.value = "";
		if (!file || !item) return;

		const hide = message.loading("Importing translations…", 0);
		importTranslationFile(file, { uiStrings, language: item, languageId: item.id })
			.then((summary) => {
				const text = describeImportSummary(summary);
				if (summary.error || summary.updated === 0) {
					message.warning(text, 8);
				} else {
					FireFetch.addLog("translations", item.id, "Import");
					message.success(text, 8);
				}
			})
			.catch((error) => message.error("Unable to import translations: " + error.message))
			.finally(hide);
	};

	useEffect(() => {
		if (arrayIn) {
			var tempArray = [];
			arrayIn.map((item, index) => {

				const progress = getTranslationProgress(uiStrings, translations?.[item.id]);
				tempArray.push({
					key: index,
					language: item.languageName,
					progress: (
						<Tooltip title={`${progress.translated} translated · ${progress.stale} need re-translation (English changed) · ${progress.missing} missing`}>
							<span>{progress.translated} / {progress.total}</span>
							{progress.stale > 0 && <Tag color="orange" className="ml-2">{progress.stale} stale</Tag>}
							{progress.missing > 0 && <Tag color="red" className="ml-2">{progress.missing} missing</Tag>}
						</Tooltip>
					),
					action: (
						<TableActionMenu
							items={[
								canUpdate && {
									key: "edit",
									label: "Edit",
									onClick: () => {
										setLayout(<LangEditLayout callback={handleCallback} langItem={item} canUpdate={canUpdate} />);
										setShowModal(true);
									},
								},
								{
									key: "export-missing",
									label: "Export untranslated strings",
									onClick: () => handleExport(item, "missing"),
								},
								{
									key: "export-all",
									label: "Export all strings",
									onClick: () => handleExport(item, "all"),
								},
								canUpdate && {
									key: "import",
									label: "Import translations",
									onClick: () => startImport(item),
								},
								(item.translationFilePath || item.languageID) && {
									key: "download",
									label: "Download original upload",
									onClick: () => downloadLanguageFile(item),
								},
								canDelete && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (confirm("Delete this language?")) {
											props.messageBack("languages", "delete", item.id);
										}
									},
								},
							]}
						/>
					)
				})
			});

			setLanguagesArray(tempArray);
		}

	}, [arrayIn, uiStrings, translations, props, canDelete, canUpdate]);




	return (
		<div className="font-Nunito">
			<Dialog
				isShown={showModal}
				title={"Edit Language"}
				onCloseComplete={() => { setShowModal(false); }}
				hasFooter={false}
			>
				<MDBBox>
					<MDBRow>
						<MDBCol md={12} className="d-flex flex-column">
							{layout}
						</MDBCol>
					</MDBRow>
				</MDBBox>
			</Dialog>
			<input
				ref={importInput}
				type="file"
				accept=".xlsx, .xls, .csv"
				style={{ display: "none" }}
				onChange={handleImport}
			/>
			<div>
				{canCreate && (
					<Button appearance="primary" className="ml-3  my-2" onClick={() => { props.messageBack("languages", "create") }}>
						New Language <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Languages",
						exportButtons: false,
						sheetname: "Languages",
					}), languagesArray);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">

				<div>
					<Table style={{ overflow: "auto" }} id={"dataTable"} loading={loading}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
						dataSource={languagesArray} columns={columns} />
				</div>
			</Card>
		</div>

	);


}

export default LanguageLayout;
